import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { bookFromWire, catalogFrom, type Book, type BookCatalog } from '@sharpr/types';
import { useBookCatalogContext } from '@sharpr/ui';

async function fetchBooks(): Promise<Book[]> {
  const res = await fetch('/api/books');
  if (!res.ok) throw new Error(`Books fetch failed: ${res.statusText}`);
  return ((await res.json()) as { books: Parameters<typeof bookFromWire>[0][] }).books.map(bookFromWire);
}

/** The sportsbook catalog: the server-prefetched books at first paint, the live `/api/books` once loaded. */
export function useBookCatalog(): BookCatalog {
  const initial = useBookCatalogContext();
  const { data } = useQuery({
    queryKey: ['books'] as const,
    queryFn: fetchBooks,
    initialData: initial.size > 0 ? [...initial.values()] : undefined,
    initialDataUpdatedAt: 0,
    staleTime: 10 * 60 * 1000,
  });
  return useMemo(() => (data ? catalogFrom(data) : initial), [data, initial]);
}
